<div>
  <nz-page-header class="bg-slate-100" [nzGhost]="false">
    <nz-page-header-title class=" text-primary flex items-center gap-2">
      {{ 'itineraries.list.title' | transloco }}
      <nz-icon  nz-tooltip
                nzTooltipPlacement = 'right'
               [nzTooltipArrowPointAtCenter]="true"
               [nzTooltipTitle]="'nav.featureTooltips.itinerary' | transloco"
                [nzTooltipOverlayStyle]="{
                      'max-width': '400px',
                      'min-width': '300px',
                      'white-space': 'normal',
                      'line-height': '1.5'
                    }"
               nz-icon nzType="info-circle" nzTheme="outline">
      </nz-icon>
    </nz-page-header-title>
    <nz-page-header-extra>
      <nz-space class="flex flex-col-reverse md:flex-row justify-end gap-3">
        <div class="mt-2 md:mt-0">
          <nz-input-group nzSearch [nzAddOnAfter]="suffixButton" [nzSuffix]="inputClearTpl">
            <input
              type="text"
              nz-input
              [placeholder]="'itineraries.list.searchPlaceholder' | transloco"
              (keydown.enter)="this.search()"
              [(ngModel)]="itinerarySearchName"/>
          </nz-input-group>
          <ng-template #inputClearTpl>
                <span
                  *ngIf="itinerarySearchName"
                  nz-icon
                  class="ant-input-clear-icon"
                  nzTheme="fill"
                  nzType="close-circle"
                  (click)="reset()"
                ></span>
          </ng-template>
          <ng-template #suffixButton>
            <button
              nz-button
              nzType="primary"
              (click)="search()"
              nzSearch>
              {{ 'itineraries.list.searchButton' | transloco }}
            </button>
          </ng-template>
        </div>
        <div>
          <button
            *appHasAnyPrivilege="'ITINERARY.ADD'"
            nz-button
            nzType="primary"
            routerLink="/admin/itineraries/add" class="flex items-center justify-center gap-2">
            <lucide-icon name="file-plus" class="icon-size"></lucide-icon>
            {{ 'itineraries.list.newItineraryButton' | transloco }}
          </button>
        </div>
        <div>
          <button
            *appHasAnyPrivilege="'ITINERARY.TEMPLATE.VIEW'"
            nz-button
            nzType="primary"
            routerLink="/admin/itineraries/template" class="flex items-center">
            {{ 'itineraries.list.templateButton' | transloco }}
          </button>
        </div>
      </nz-space>
    </nz-page-header-extra>
  </nz-page-header>
</div>
<div class="my-4">
  <div class="flex justify-end items-center mx-5 my-2 gap-4">
    <div class="flex items-center gap-2" *ngIf="authService.isSuperAdmin()">
      <nz-select
        [(ngModel)]="selectedCreator"
        [nzPlaceHolder]="'itineraries.list.filterByCreator' | transloco"
        nzAllowClear
        style="width: 200px;"
        (ngModelChange)="onCreatorChange()">
        <nz-option
          *ngFor="let creator of creators"
          [nzValue]="creator._id"
          [nzLabel]="creator.name">
        </nz-option>
      </nz-select>
    </div>
    <nz-switch
      [ngModel]="this.archieved"
      (ngModelChange)="this.onChangeSwitch($event)"
      [nzCheckedChildren]="checkedTemplate"
      [nzUnCheckedChildren]="unCheckedTemplate"
    ></nz-switch>
    <ng-template #checkedTemplate><span class="m-3  mt-3.5 flex items-center justify-center text-[0.8rem]">{{ 'itineraries.list.archived' | transloco }}</span></ng-template>
    <ng-template #unCheckedTemplate><span class="m-3  mt-3.5  flex items-center justify-center text-[0.8rem]">{{ 'itineraries.list.unarchived' | transloco }}</span></ng-template>
    <span
      class="hover:cursor-pointer text-gray-500"
      nz-tooltip
      [nzTooltipTitle]="'itineraries.list.editTableView' | transloco"
      (click)="openTableViewModal()">
      <lucide-icon name="cog"></lucide-icon>
    </span>
  </div>
  <nz-table
    #itineraryTable
    [nzData]="itineraries"
    [nzShowSizeChanger]="pageSize.length > 5"
    [nzPageSizeOptions]="pageSize.pageSizeOptions"
    [nzBordered]="true"
    [nzPageSize]="pageSize.pageSize"
    [nzPageIndex]="pageSize.pageIndex"
    [nzFrontPagination]="false"
    [nzTotal]="pageSize.length"
    (nzQueryParams)="onTableParamsChange($event)"
    [nzScroll]="{ x: '1200px' }">
    <thead>
    <tr>
      <th nzWidth="190px" *ngIf="isColumnVisible('referenceNumber')">{{ 'itineraries.list.table.referenceNumber' | transloco }}</th>
      <th nzWidth="90px" *ngIf="isColumnVisible('clientViews')">{{ 'itineraries.list.table.clientViews' | transloco }}</th>
      <th
        nzWidth="160px"
        *ngIf="isColumnVisible('customerName')"
        [nzSortFn]="sortColumn.compareName"
        (click)="sortByName()">
        {{ 'itineraries.list.table.customerName' | transloco }}
      </th>
      <th nzWidth="160px" *ngIf="isColumnVisible('itineraryTitle')">
        {{ 'itineraries.list.table.itineraryTitle' | transloco }}
      </th>
      <th nzWidth="120px" *ngIf="isColumnVisible('arrival')" [nzSortFn]="sortColumn.compareDate">{{ 'itineraries.list.table.arrival' | transloco }}</th>
      <th nzWidth="120px" *ngIf="isColumnVisible('departure')" [nzSortFn]="sortColumn.compareDate">{{ 'itineraries.list.table.departure' | transloco }}</th>
      <th nzWidth="80px" *ngIf="isColumnVisible('days')">{{ 'itineraries.list.table.days' | transloco }}</th>
      <th nzWidth="80px" *ngIf="isColumnVisible('pax')">{{ 'itineraries.list.table.pax' | transloco }}</th>
      <th nzWidth="120px"
          *ngIf="isColumnVisible('language')"
          nzColumnKey="language"
          [nzFilters]="languageFilters"
          [nzFilterMultiple]="false"
          [nzShowFilter]="true"
          [nzFilterFn]="filterLanguageFn">
        {{ 'itineraries.list.table.language' | transloco }}
      </th>
      <th nzWidth="100px"
          *ngIf="isColumnVisible('type')"
          nzColumnKey="type"
          [nzFilters]="typeFilters"
          [nzFilterMultiple]="false"
          [nzShowFilter]="true"
          [nzFilterFn]="filterTypeFn">
        {{ 'itineraries.list.table.type' | transloco }}
      </th>
      <th nzWidth="100px" *ngIf="isColumnVisible('currency')">{{ 'itineraries.list.table.currency' | transloco }}</th>
      <th nzWidth="170px" *ngIf="isColumnVisible('creator')">{{ 'itineraries.list.table.creator' | transloco }}</th>
      <th nzWidth="160px"
          *ngIf="isColumnVisible('status')"
          nzColumnKey="status"
          [nzFilters]="statusFilters"
          [nzFilterMultiple]="false"
          [nzShowFilter]="true"
          [nzFilterFn]="filterStatusFn">
        {{ 'itineraries.list.table.status' | transloco }}
      </th>
      <th nzWidth="120px" *ngIf="isColumnVisible('created')" [nzSortFn]="sortColumn.compareDate">
        {{ 'itineraries.list.table.created' | transloco }}
      </th>
      <th nzWidth="250px">{{ 'itineraries.list.table.actions' | transloco }}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let data of itineraryTable.data">
      <td *ngIf="isColumnVisible('referenceNumber')">
        <div class="flex justify-start items-center gap-2">
          <ng-container *ngIf="data?.isCreatedFromTemplate">
            <nz-icon nz-tooltip [nzTooltipTitle]="'itineraries.list.createdFromTemplate' | transloco"
              nz-icon nzType="export" nzTheme="outline">
            </nz-icon>
          </ng-container>
          <a [routerLink]="'/admin/itineraries/edit/' + data._id" target="_blank">{{ data.tour.referenceNo }}</a>
          <ng-container *ngIf="data.remarks">
            <nz-icon [nzTooltipTrigger]="'click'" nz-tooltip
                     [nzTooltipTitle]="data.remarks"
                     nz-icon nzType="info-circle" nzTheme="outline">
            </nz-icon>
          </ng-container>
        </div>
      </td>
      <td *ngIf="isColumnVisible('clientViews')">
         {{data?.viewCount ? data.viewCount : 0 }}
      </td>
      <td *ngIf="isColumnVisible('customerName')">
        <div class="flex items-center">
          <div class="capitalize">{{ data?.full_name !== " " ? data?.full_name : getEmptyValue() }}</div>
        </div>
      </td>
      <td *ngIf="isColumnVisible('itineraryTitle')">
        {{ data?.title !== '' ? data?.title : getEmptyValue() }}
      </td>
      <td *ngIf="isColumnVisible('arrival')">{{ !data.tour.isDatesOptional ? (data.tour.startDate | date) : getEmptyValue() }}</td>
      <td *ngIf="isColumnVisible('departure')">{{ !data.tour.isDatesOptional ? (data.tour.endDate | date) : getEmptyValue() }}</td>
      <td *ngIf="isColumnVisible('days')">{{ data.tour.noOfDays }}</td>
      <td *ngIf="isColumnVisible('pax')">{{ data.tour.pax.adults + data.tour.pax.children }}</td>
      <td *ngIf="isColumnVisible('language')" class="capitalize">{{ languageByCode(data.tour.language) }}</td>
      <td *ngIf="isColumnVisible('type')">{{ getTranslatedTypeLabel(data.tour.type) }}</td>
      <td *ngIf="isColumnVisible('currency')" class="uppercase">{{ data.tour.currency }}</td>
      <td *ngIf="isColumnVisible('creator')">
        <span>{{ data.creator.name }}</span>
      </td>
      <td *ngIf="isColumnVisible('status')">
        <nz-tag [nzColor]='this.getStatusColor(data.status)'>
          {{ getTranslatedStatusLabel(data.status) }}
        </nz-tag>
      </td>
      <td *ngIf="isColumnVisible('created')">{{ data.createdAt | date }}</td>
      <td *ngIf="this.archieved">
        <button
          *appHasAnyPrivilege="'ITINERARY.ARCHIVE'"
          nz-button
          nzType="default"
          nzSize="small"
          (click)="showArchiveConfirm(data._id, data.isArchived)">
          {{ !data.isArchived ? ('itineraries.list.actions.archive' | transloco) : ('itineraries.list.actions.unarchive' | transloco) }}
        </button>
      </td>
      <td *ngIf="!this.archieved">
        <div class="flex flex-row items-center">
          <a
            *appHasAnyPrivilege="'ITINERARY.EDIT'"
            nz-button
            nzType="default"
            nzSize="small"
            target="_blank"
            [routerLink]="'/admin/itineraries/edit/' + data._id"
            class="flex items-center justify-center gap-2">
            <lucide-icon name="pencil" class="icon-size"></lucide-icon>
            {{ 'itineraries.list.actions.edit' | transloco }}
          </a>
          <nz-divider nzType="vertical"></nz-divider>
          <a
            *appHasAnyPrivilege="'ITINERARY.PREVIEW'"
            nz-button
            nzType="primary"
            nzSize="small"
            target="_blank"
            (click)="onClickNavigateToPreview(data)" class=" ml-1 flex items-center justify-center gap-2">
            <lucide-icon name="eye" class="icon-size"></lucide-icon>
          </a>
          <nz-divider nzType="vertical"></nz-divider>
          <button
            nz-button
            nz-dropdown
            nzType="text"
            [nzOverlayStyle]="{ bottom: '-40px'}"
            [nzDropdownMenu]="menuDropdown">
            <span nz-icon nzType="ellipsis"></span>
          </button>
          <nz-dropdown-menu #menuDropdown="nzDropdownMenu">
            <ul nz-menu>
              <li class="m-0"
                nz-submenu [nzTitle]="'itineraries.list.actions.share' | transloco">
                <ul>
                  <ng-container
                    *ngIf="this.organizationSetting?.notification?.isB2bItineraryLinkEnabled">
                    <li *ngIf="data?.tour?.type !== 'B2C'  && !data?.isB2BExpired" [ngStyle]="{ color: !data.isSharingEnabled ? 'red' : null }" [nzDisabled]="!data.isSharingEnabled" nz-menu-item nz-button (click)="data.isSharingEnabled ? copyEditableLink(data) : ''">
                      {{ 'itineraries.list.actions.copyEditableLink' | transloco }}
                    </li>
                    <li *ngIf="data?.tour?.type !== 'B2C'  && data?.isB2BExpired"  [ngStyle]="{ color: !data.isSharingEnabled ? 'red' : null }" [nzDisabled]="!data.isSharingEnabled" nz-menu-item nz-button (click)="data.isSharingEnabled ? generateEditableLink(data) : ''">
                      {{ 'itineraries.list.actions.generateEditableLink' | transloco }}
                    </li>
                  </ng-container>
                  <ng-container
                    *ngIf="!this.organizationSetting?.notification?.isB2bItineraryLinkEnabled">
                    <li *ngIf="data?.tour?.type !== 'B2C'" [ngStyle]="{ color: !data.isSharingEnabled ? 'red' : null }" [nzDisabled]="!data.isSharingEnabled" nz-menu-item nz-button (click)="data.isSharingEnabled ? copyEditableLink(data) : ''">
                      {{ 'itineraries.list.actions.copyEditableLink' | transloco }}
                    </li>
                  </ng-container>
                  <li *ngIf="data?.tour?.type !== 'B2B'" nz-menu-item nz-button  [ngStyle]="{ color: !data.isSharingEnabled ? 'red' : null }" [nzDisabled]="!data.isSharingEnabled" (click)="data.isSharingEnabled ? copyShareLink(data) : ''">
                    {{ 'itineraries.list.actions.copyShareLink' | transloco }}
                  </li>
                  <li
                    *appHasAnyPrivilege="'ITINERARY.DISABLE.SHARING'"
                    nz-menu-item
                    nz-button
                    (click)="showRevokeAccessConfirm(data._id, data.isSharingEnabled)">
                    {{ !data.isSharingEnabled ? ('itineraries.list.actions.enableSharing' | transloco) : ('itineraries.list.actions.disableSharing' | transloco) }}
                  </li>
                  <ng-container
                    *ngIf="data?.tour?.type !== 'B2C' && this.organizationSetting?.notification?.isB2bItineraryLinkEnabled">
                    <li
                      *appHasAnyPrivilege="'ITINERARY.LINK.EXPIRATION'"
                      nz-menu-item
                      nz-button
                      (click)="linkExpirationConfirm(data._id, data.isLinkExpirationEnabled)">
                      {{ !data.isLinkExpirationEnabled
                          ? ('itineraries.list.actions.enableLinkExpiration' | transloco)
                          : ('itineraries.list.actions.disableLinkExpiration' | transloco) }}
                    </li>
                  </ng-container>
                  <li
                    *appHasAnyPrivilege="'ITINERARY.DISABLE.NOTIFICATION'"
                    nz-menu-item
                    nz-button
                    (click)="showViewNotificationConfirm(data._id, data.isNotificationEnabled)">
                    {{ !data.isNotificationEnabled ? ('itineraries.list.actions.enableViewNotifications' | transloco) : ('itineraries.list.actions.disableViewNotifications' | transloco) }}
                  </li>
                </ul>
              </li>
              <li class="m-0"
                [ngClass]="data?.tour?.type === 'B2C' ? '' : 'hidden'"
                *appHasAnyPrivilege="'ITINERARY.SEND.ITINERARY'"
                nz-menu-item
                nz-button
                (click)="
                  sendItineraryShowModal(
                    data._id,
                    data.creator,
                    data.full_name,
                    data.tour.customer.email,
                    data.tour.themeType
                  )
                ">
                {{ 'itineraries.list.actions.sendItinerary' | transloco }}
              </li>
              <li class="m-0"
                *appHasAnyPrivilege="'ITINERARY.DOWNLOAD.PDF'"
                nz-menu-item nz-button (click)="exportContent(data._id, data.viewSettings, data.tour.themeType)">
                {{ 'itineraries.list.actions.export' | transloco }}
              </li>
              <li class="m-0" nz-menu-item nz-button (click)="this.generateSimpleWord(data._id)">
                {{ 'itineraries.list.actions.downloadWord' | transloco }}
              </li>
              <li class="m-0"
                *appHasAnyPrivilege="'ITINERARY.TEMPLATE.SAVEITINERARYAS'"
                nz-menu-item
                nz-button
                (click)="saveAsTemplate(data._id)">
                {{ 'itineraries.list.actions.saveAsTemplate' | transloco }}
              </li>
              <li class="m-0"
                *appHasAnyPrivilege="'ITINERARY.CHANGE.STATUS'"
                nz-submenu [nzTitle]="'itineraries.list.actions.status' | transloco">
                <ul>
                  <li nz-menu-item nz-button
                      (click)="statusChangeOpenModel(data, SETTINGS.ITINERARY_STATUSES.DRAFT)">
                    {{ 'itineraries.list.statuses.draft' | transloco }}
                  </li>
                  <li nz-menu-item nz-button
                      (click)="statusChangeOpenModel(data, SETTINGS.ITINERARY_STATUSES.SENT)">
                    {{ 'itineraries.list.statuses.sent' | transloco }}
                  </li>
                  <li nz-menu-item nz-button
                      (click)="statusChangeOpenModel(data, SETTINGS.ITINERARY_STATUSES.FOLLOW_UP)">
                    {{ 'itineraries.list.statuses.followUp' | transloco }}
                  </li>
                  <li nz-menu-item nz-button
                      (click)="statusChangeOpenModel(data, SETTINGS.ITINERARY_STATUSES.CONFIRMED)">
                    {{ 'itineraries.list.statuses.confirm' | transloco }}
                  </li>
                  <li
                    *appHasAnyPrivilege="'ITINERARY.SEND.INVOICE'"
                    nz-menu-item
                    nz-button
                    (click)="statusChangeOpenModel(data, SETTINGS.ITINERARY_STATUSES.INVOICE_SENT)">
                    {{ 'itineraries.list.statuses.invoiceSent' | transloco }}
                  </li>
                  <li nz-menu-item nz-button (click)="statusChangeOpenModel(data, SETTINGS.ITINERARY_STATUSES.PAID)">
                    {{ 'itineraries.list.statuses.paid' | transloco }}
                  </li>
                  <li nz-menu-item nz-button (click)="statusChangeOpenModel(data, SETTINGS.ITINERARY_STATUSES.LOST)">
                    {{ 'itineraries.list.statuses.lost' | transloco }}
                  </li>
                  <li nz-menu-item nz-button
                      (click)="statusChangeOpenModel(data, SETTINGS.ITINERARY_STATUSES.CANCELLED)">
                    {{ 'itineraries.list.statuses.cancel' | transloco }}
                  </li>
                </ul>
              </li>
              <li class="m-0"
                *appHasAnyPrivilege="'ITINERARY.DUPLICATE'"
                nz-menu-item nz-button (click)="onDuplicateItinerary(data._id)">
                {{ 'itineraries.list.actions.duplicateItinerary' | transloco }}
              </li>
              <li class="m-0"
                [ngClass]="data?.tour?.type === 'B2C' ? '' : 'hidden'"
                *appHasAnyPrivilege="'ITINERARY.SEND.INVOICE'"
                nz-menu-item
                nz-button
                (click)="
                  sendInvoiceShowModal(
                    data._id,
                    data.full_name,
                    data.tour.currency,
                    data.costing,
                    data.costSettings.isDynamicPricing,
                    data.tour.pax.adults,
                    data.tour.pax.children,
                    data.tour.customer.email,
                    data.tour.referenceNo,
                    data.tour.themeType
                  )
                ">
                {{ 'itineraries.list.actions.sendInvoice' | transloco }}
              </li>
              <li class="m-0"
                *appHasAnyPrivilege="'ITINERARY.COST.BREAKDOWN'"
                nz-menu-item
                nz-button
                [routerLink]="'/admin/itineraries/costbreakdown/' + data._id+'/'"
              >
                {{ 'itineraries.list.actions.viewCosting' | transloco }}
              </li>
              <li class="m-0"
                nz-menu-item
                nz-button
                *appHasAnyPrivilege="'ITINERARY.STATUS.LOG'"
                [routerLink]="'/admin/itineraries/status-logs/' + data._id+'/' + data.tour.referenceNo">
                {{ 'itineraries.list.actions.viewStatusLog' | transloco }}
              </li>
              <li class="m-0"
                [ngClass]="data?.tour?.type === 'B2B' ? 'block' : 'hidden'"
                nz-menu-item
                nz-button
                *appHasAnyPrivilege="'ITINERARY.AGENT'"
                (click)="this.viewAgentContent(data?._id)">
                {{ 'itineraries.list.actions.viewAgent' | transloco }}
              </li>
              <li class="m-0"
                *appHasAnyPrivilege="'ITINERARY.ARCHIVE'"
                nz-menu-item
                nz-button
                (click)="showArchiveConfirm(data._id, data.isArchived)">
                {{ !data.isArchived ? ('itineraries.list.actions.archive' | transloco) : ('itineraries.list.actions.unarchive' | transloco) }}
              </li>
              <li class="m-0"
                *appHasAnyPrivilege="'ITINERARY.DELETE'"
                nz-menu-item
                nz-button
                (click)="showDeleteConfirm(data._id)"
                nzDanger>
                {{ 'itineraries.list.actions.delete' | transloco }}
              </li>
            </ul>
          </nz-dropdown-menu>
        </div>
      </td>
    </tr>
    </tbody>
  </nz-table>
</div>

<nz-modal
  [(nzVisible)]="sendEmailIsVisible"
  [nzTitle]="modalTitle"
  (nzOnCancel)="sendEmailCancel('emailModal')">
  <ng-container *nzModalContent>
    <div>
      <form nz-form [formGroup]="emailForm">
        <nz-form-item class="mb-1">
          <nz-form-label class="text-start w-20" nzFor="sendEmailTo"
          >{{ 'itineraries.emailModal.fields.to' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="emailToCheck">
            <nz-select
              nzMode="tags"
              [nzPlaceHolder]="'itineraries.emailModal.placeholders.receiverEmail' | transloco"
              formControlName="sendEmailTo"
              nzPlacement="topLeft"
              (ngModelChange)="setDefaultClientMail($event)">
            </nz-select>
          </nz-form-control>
          <ng-template class="m-0" #emailToCheck>
            <span *ngIf="formErrors.sendEmailTo.required">
              {{ 'itineraries.emailModal.errors.emailRequired' | transloco }}
            </span>
            <span *ngIf="formErrors.sendEmailTo.email">
              {{ 'itineraries.emailModal.errors.emailInvalid' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="mb-1">
          <nz-form-label class="text-start w-20" nzFor="sendEmailCc"
          >{{ 'itineraries.emailModal.fields.cc' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="emailCcCheck">
            <nz-input-group>
              <nz-select
                nzMode="tags"
                [nzPlaceHolder]="'itineraries.emailModal.placeholders.receiverEmail' | transloco"
                formControlName="sendEmailCc"
                nzPlacement="topLeft">
              </nz-select>
            </nz-input-group>
          </nz-form-control>
          <ng-template #emailCcCheck>
            <span *ngIf="formErrors.sendEmailCc.email"> {{ 'itineraries.emailModal.errors.emailInvalid' | transloco }} </span>
          </ng-template>
        </nz-form-item>
        <nz-form-item class="mb-1">
          <nz-form-label class="text-start w-20" nzFor="sendEmailSubject"
          >{{ 'itineraries.emailModal.fields.subject' | transloco }}
          </nz-form-label>
          <nz-form-control [nzErrorTip]="subjectCheck">
            <nz-input-group>
              <input
                class="custom-email-sub-radius"
                nz-input
                type="text"
                [placeholder]="'itineraries.emailModal.placeholders.emailSubject' | transloco"
                formControlName="sendEmailSubject"/>
            </nz-input-group>
          </nz-form-control>
          <ng-template #subjectCheck>
            <span *ngIf="formErrors.sendEmailSubject.required">
              {{ 'itineraries.emailModal.errors.subjectRequired' | transloco }}
            </span>
          </ng-template>
        </nz-form-item>
      </form>
    </div>
    <div *ngIf="this.sendInfo.type === 'Itinerary'" class="mt-3">
      <label
        nz-checkbox
        [(ngModel)]="this.attachWithPDFChecked"
        [ngModelOptions]="{standalone: true}"
      >{{ 'itineraries.emailModal.attachPdfItinerary' | transloco }}</label>
    </div>
  </ng-container>
  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="sendEmailCancel('emailModal')">
      {{ 'itineraries.emailModal.actions.cancel' | transloco }}
    </button>
    <button
      nz-button
      nzType="primary"
      [disabled]="emailForm.invalid"
      (click)="sendEmailConfirmModal()">
      {{ 'itineraries.emailModal.actions.send' | transloco }}
    </button>
  </div>
</nz-modal>

<nz-modal
  [(nzVisible)]="sendEmailConfirmIsVisible"
  [nzTitle]="modalTitleConfirmBox"
  (nzOnCancel)="sendEmailCancel('confirmModal')">
  <ng-container *nzModalContent>
    <div>
      <p>
        <span *ngIf="sendInfo.type === 'Itinerary'"
        >{{ 'itineraries.emailModal.confirmations.sendItinerary' | transloco }}
        </span>
        <span *ngIf="sendInfo.type === 'Invoice'"
        >{{ 'itineraries.emailModal.confirmations.sendInvoice' | transloco }}
        </span>
      </p>
    </div>
  </ng-container>
  <div *nzModalFooter>
    <button
      nz-button
      nzType="default"
      (click)="sendEmailCancel('confirmModal')">
      {{ 'itineraries.emailModal.actions.cancel' | transloco }}
    </button>
    <button nz-button nzType="primary" (click)="SendEmail()">{{ 'itineraries.emailModal.actions.confirm' | transloco }}</button>
  </div>
</nz-modal>

<nz-modal
  [(nzVisible)]="this.isStatusChangeVisible"
  [nzTitle]="'itineraries.statusChangeModal.title' | transloco"
  (nzOnCancel)="this.statusChangeCancel()">
  <ng-container *nzModalContent>
    <div class="mb-8">
      <p class="font-normal">{{ 'itineraries.statusChangeModal.confirmText' | transloco:{ status: this.selectedStatus } }}</p>
    </div>
    <nz-form-item>
      <nz-form-label nzFor="remarks">
        {{ 'itineraries.statusChangeModal.fields.remarksOptional' | transloco }}
      </nz-form-label>
      <nz-form-control>
        <textarea
          class="w-full"
          [(ngModel)]="this.statusChangeRemarks"
          [placeholder]="'itineraries.statusChangeModal.placeholders.remarks' | transloco"
          rows="4" nz-input>
        </textarea>
      </nz-form-control>
    </nz-form-item>
  </ng-container>
  <div *nzModalFooter>
    <button
      nz-button
      nzType="default"
      (click)="this.statusChangeCancel()">
      {{ 'itineraries.statusChangeModal.actions.cancel' | transloco }}
    </button>
    <button nz-button nzType="primary" (click)="onClickUpdateItinerary(this.selectedItinerary, this.selectedStatus)">{{ 'itineraries.statusChangeModal.actions.submit' | transloco }}</button>
  </div>
</nz-modal>

<nz-modal
  [(nzVisible)]="isTableViewModalVisible"
  [nzTitle]="'itineraries.list.tableViewModal.title' | transloco"
  [nzFooter]="tableViewFooter"
  (nzOnCancel)="closeTableViewModal()">
  <ng-container *nzModalContent>
    <p class="text-gray-500 mb-4">{{ 'itineraries.list.tableViewModal.description' | transloco }}</p>
    <div class="grid grid-cols-2 gap-4">
      <div *ngFor="let col of tableColumns" class="flex items-center gap-2">
        <label nz-checkbox [(ngModel)]="tempColumnVisibility[col.key]">
          {{ col.label | transloco }}
        </label>
      </div>
    </div>
  </ng-container>
  <ng-template #tableViewFooter>
    <button nz-button nzType="default" (click)="closeTableViewModal()">
      {{ 'itineraries.list.tableViewModal.cancel' | transloco }}
    </button>
    <button nz-button nzType="primary" (click)="updateTableView()">
      {{ 'itineraries.list.tableViewModal.update' | transloco }}
    </button>
  </ng-template>
</nz-modal>
